// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*@import url("moteur-recherche-remplace.component.scss");*/
/* Import Tailwind base styles */
:host(.home_search) .moteur-de-recherhe {
  display: block;
  width: 790px;
  position: absolute;
  top: 50%;
  position: relative;
  z-index: 5;
  margin-left: auto;
  margin-right: auto;
}

:host(.home_search) {
  width: 790px !important;
  display: block;
  margin: 0 auto;
}

:host(.dark) .moteur-de-recherhe {
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.33);
  background-color: #4c4c4c;
}

:host(.dark) ::ng-deep .moteur-de-recherhe .dynamique-style {
  background-color: #4c4c4c !important;
  color: #dddddd;
}

:host(.dark) ::ng-deep .moteur-de-recherhe input::placeholder {
  color: #868484;
}

:host(.light) ::ng-deep .moteur-de-recherhe input {
  background: transparent !important;
}

.moteur-de-recherhe {
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  color: #242526;
  box-sizing: border-box;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  background: #fff;
  border-radius: 50px;
  padding: 0px 7px 0px 10px;
  height: 65px;
  width: 100%;
  display: flex !important;
  margin: 0;
  flex-wrap: nowrap;
}

.zone-input {
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  color: #242526;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  float: left;
  border-right: 1px solid #6d6c6c;
}

.zone-input-qui {
  border-right: none;
}

.zone-input-qui > div {
  position: relative;
}

.input-ou {
  position: relative;
  vertical-align: top;
  margin-bottom: 15px;
}

.input-qui {
  position: relative;
  vertical-align: top;
}

input:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.btn {
  border-radius: 50px;
  margin: 7px 0px;
  border: 0;
  color: #fff;
  overflow: hidden;
  z-index: 1;
  background-color: #009688;
}

.search-additional-btn:hover {
  background-color: rgb(226, 225, 225);
}

.search-additional-btn {
  width: 22px;
  border-radius: 0 55px 55px 0;
  margin: 7px 0px;
  margin-left: 8px;
  padding: 0 5px;
  height: 51px;
  line-height: 51px;
  float: right;
  border: 0;
  font-size: 14px;
  color: #1976d2;
  box-shadow: none;
  position: relative;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;
  will-change: all;
  order: 5;
}

.padd {
  padding-left: 13px !important;
}

.search-additional-btn-left {
  order: 0;
  border-radius: 55px 0 0 55px;
  margin: 7px 0;
  margin-right: 0px !important;
  padding: 0px !important;
  max-width: 32px !important;
  float: left;
}

.search-additional-btn-rigth {
  margin-left: 0 !important;
}

.form-group {
  margin: 0px;
  padding: 0;
  float: left;
  width: 100%;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-size: 14px;
  font-weight: 500;
  height: 46px;
  border: 0px;
  margin: 9px 0px 10px 0px;
  border-radius: 0px;
  padding-left: 25px;
}

.autocomplete {
  position: absolute;
  top: 20px;
  left: -50px;
  width: 200% !important;
  z-index: 8;
  background-color: white;
  border-radius: 0.5em;
  max-width: 415px !important;
}

@media only screen and (max-width: 600px) {
  /* Appareils avec une résolution de 600 pixels ou moins */
  .autocomplete {
    left: -110px !important;
    max-width: 590px !important;
  }
}
/*******Autocomplete**********/
.searchbar-result-profile {
  display: flex;
}

.searchbar-result-profile-avatar {
  flex-basis: 40px;
  min-width: 40px;
  height: 40px;
}

.searchbar-result-profile-avatar img {
  width: 100%;
  height: 100%;
}

.searchbar-result-profile-details {
  padding-left: 14px;
}

.searchbar-result-profile-city {
  font-size: 12px;
  color: rgba(67, 95, 113, 0.6);
  line-height: 14px;
}

:host(.home_search) .moteur-de-recherhe .search-additional-btn {
  color: #0f847e;
}

:host(.home_search) .moteur-de-recherhe .zone-input {
  color: #0f847e;
}

:host(.home_search) .moteur-de-recherhe .btn {
  color: #fff;
  background-color: #0f847e;
}

:host(.home_search) .moteur-de-recherhe .fa-search.fa-w-16 {
  color: #fff;
}

:host(.home_search) .moteur-de-recherhe input {
  /*font-family: Roboto;*/
  font-size: 16px;
  font-weight: normal;
  caret-color: #fff;
  background: transparent !important;
}
:host(.home_search) .moteur-de-recherhe input :first-child {
  border-right: 1px solid #7f7d7d;
}

.loc {
  padding: 6px 0 0 6px;
}

.btn-search {
  width: 15%;
  float: right;
  height: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  color: #0f847e;
}

/***************** Result block *****************/
.result-block {
  position: absolute;
  z-index: 90;
  top: 3.667em;
  /*right: -0.25em;*/
  /*min-width: 30em;*/
  background: white;
  border-radius: 0.5em;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
  /*padding: 1em;*/
  line-height: 1em;
  text-align: left;
  color: #333333;
}

@media (min-width: 991px) {
  .result-block {
    min-width: 29em !important;
  }
}
.result-block .scroll {
  overflow: auto;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 200px;
}

.result-block .spec-search {
  width: 100%;
  display: inline-block;
}

.result-block .scroll::-webkit-scrollbar {
  width: 8px;
  cursor: pointer;
  -webkit-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;
  opacity: 0.1;
}

.result-block .scroll::-webkit-scrollbar:hover {
  transition: none;
  -o-transition: none;
  -ms-transition: none;
  -moz-transition: none;
  -webkit-transition: none;
  zoom: 1;
  filter: alpha(opacity=50);
  opacity: 0.9;
}

.result-block .scroll::-webkit-scrollbar-track {
  box-shadow: inset 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  -o-shadow: inset 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  -ms-shadow: inset 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  background: rgb(204, 204, 204);
  /* border-radius: 4px; */
  margin-bottom: 7px;
}

.result-block .scroll::-webkit-scrollbar-thumb {
  -box-shadow: inset 0 0 6px rgb(48, 143, 183);
  background: rgb(48, 143, 183);
}

/* IE class */
.ie .result-block {
  border: 1px solid #ccc;
}

#status-infos .result-block {
  top: 2.667em;
  display: none;
}

#status-infos > li:hover .result-block {
  display: block;
}

.result-block h2 {
  float: left;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
  opacity: 0.8;
  color: #11b3a4;
  font-size: 19px;
  font-weight: 600;
  padding-left: 10px;
  padding-top: 7px;
}

.ab {
  margin-bottom: 1px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 250px;
}

.result-block div:last-child {
  margin-bottom: 0;
}

/* IE class */
.result-block div.last-child {
  margin-bottom: 0;
}

.result-block .arrow {
  font-size: 0;
  line-height: 0;
  width: 0;
  position: absolute;
  z-index: 89;
  right: 50%;
  top: -5px;
  border-bottom: 5px solid #666666;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
}

.result-block .arrow span {
  width: 0;
  position: absolute;
  z-index: 89;
  left: -2px;
  bottom: -5px;
  border-bottom: 4px solid white;
  border-left: 2px solid transparent;
  border-right: 2px solid transparent;
}

.result-block .results-count {
  float: right;
  text-transform: uppercase;
  color: #676767;
  font-size: 0.85em;
  white-space: nowrap;
  margin-left: 1em;
  padding-top: 15px;
  padding-right: 10px;
  margin-bottom: 8px;
}

.result-block .results-count strong {
  color: #999999;
}

.result-block ul {
  clear: both;
}

.result-block ul li {
  white-space: nowrap;
}

.result-block .speciality {
  border-top: 1px solid #efefef;
  flex: 0 0 auto;
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #435f71;
  position: relative;
  cursor: pointer;
  text-align: left;
  display: flex;
  padding: 8px;
  clear: both;
  margin-bottom: 0px;
}

.result-block .speciality:hover {
  background-color: #efefef;
}

.result-block .speciality strong {
  color: #11b3a4;
}

.result-block .table-profiles {
  padding: 0;
  width: 100%;
  /*display: table;*/
  margin: 0;
  clear: both;
}

.result-block .table-profile {
  z-index: 100000;
  padding: 5px 0;
  margin: 0;
  height: 86px;
  clear: both;
  border-bottom: 1px solid #efefef;
}

.result-block .table-profile:hover {
  cursor: pointer;
  background-color: #efefef;
}

.result-block .table-profiles .table-cell {
  display: inline-grid;
  vertical-align: middle;
}

.result-block .table-profiles .table-cell:first-child {
  padding: 5px;
}

.result-block .table-profiles .table-cell .img-circle {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  box-shadow: 0 4px 6px -10px rgba(0, 0, 0, 0.5), 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 30px rgba(0, 0, 0, 0.1) inset;
}

.profile-info .name-text {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 10px;
}

.profile-info strong {
  color: #0fa0d7;
}

.profile-info .spec {
  font-size: 13px;
  margin: 3px 0px 3px 10px;
  max-width: 300px;
  color: grey;
  font-style: italic;
  font-family: sans-serif;
}

.profile-info .location {
  display: flex;
  align-items: center;
  justify-self: start;
  font-size: 14px;
  margin-left: 6px;
  font-weight: 600;
  color: #4c4c4c;
}

.search-more,
.search-less {
  display: block;
  color: #999999;
  font-size: 0.75em;
  text-transform: uppercase;
  padding: 0.333em 0;
  text-align: center;
  background-size: 100% 100%;
  background: -moz-linear-gradient(top, rgb(255, 255, 255), rgba(255, 255, 255, 0)), -moz-linear-gradient(left, #ffffff, #ebebeb 50%, #ffffff);
  background: -webkit-gradient(linear, left top, left bottom, from(rgb(255, 255, 255)), to(rgba(255, 255, 255, 0))), -webkit-gradient(linear, left top, right top, from(#ffffff), to(#ffffff), color-stop(0.5, #ebebeb));
}

.search-more:hover,
.search-less:hover {
  color: #3399cc;
}

ul + .search-more,
ul + .search-less {
  margin-top: -1.333em;
}

ul.small-pagination + .search-more,
ul.small-pagination + .search-less {
  margin-top: -0.667em;
}

.search-more:before {
  padding-right: 0.556em;
}

.search-more:after {
  padding-left: 0.556em;
}

.search-less:before {
  padding-right: 0.556em;
}

.search-less:after {
  padding-left: 0.556em;
}

.result-block hr {
  height: 1px;
  line-height: 1px;
  border: 0;
  margin-top: 0;
  margin-bottom: 0;
  clear: both;
  background-size: 100% 100%;
  background: -moz-linear-gradient(left, #ffffff, #cccccc 50%, #ffffff);
  background: -webkit-gradient(linear, left top, right top, from(#ffffff), to(#ffffff), color-stop(0.5, #cccccc));
}

.result-block .result-info {
  background: #333333;
  color: white;
  padding: 0.417em 0.75em 0.583em;
  /* margin: 0 -1em -1em -1em;*/
  border-radius: 0 0 0.5em 0.5em;
  white-space: nowrap;
  margin-bottom: 0px !important;
}

.result-block .result-info a {
  color: #77ccff;
}

.result-block .arrow:first-child + .result-info:last-child {
  margin-top: -1em;
  border-top: 1px solid #999999;
  border-radius: 0.5em;
}

/* IE class */
.result-block .result-info.first-last-child {
  margin-top: -1em;
  border-top: 1px solid #999999;
}

.result-block div + .result-info,
.result-block p + .result-info,
.result-block ul + .result-info {
  margin-top: 0;
}

.result-block .result-info.loading {
  padding-left: 2.667em;
  background: #333333 url(https://cdn.tictacsante.com/assets/icons/loader.gif) no-repeat 0.75em center;
}

.result-block-loc {
  top: 9.3em;
}

:host(.home_search) .moteur-de-recherhe {
  display: block;
  z-index: 2;
  position: absolute;
  top: 50%;
}
:host(.home_search) .moteur-de-recherhe .result-block-loc {
  top: 5em;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container{
  width: 100%;
}
@media (min-width: 640px){
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.z-10{
  z-index: 10;
}
.m-0{
  margin: 0px;
}
.m-3{
  margin: 0.75rem;
}
.m-4{
  margin: 1rem;
}
.m-auto{
  margin: auto;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-40{
  margin-bottom: 10rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.table-cell{
  display: table-cell;
}
.grid{
  display: grid;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.size-11{
  width: 2.75rem;
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-5{
  height: 1.25rem;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-full{
  height: 100%;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-44{
  width: 11rem;
}
.w-5{
  width: 1.25rem;
}
.w-full{
  width: 100%;
}
.max-w-sm{
  max-width: 24rem;
}
.flex-1{
  flex: 1 1 0%;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.columns-3{
  columns: 3;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.content-center{
  align-content: center;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-2{
  gap: 0.5rem;
}
.gap-4{
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.border{
  border-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-none{
  border-style: none;
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-2{
  padding: 0.5rem;
}
.p-4{
  padding: 1rem;
}
.p-8{
  padding: 2rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-5{
  padding-left: 1.25rem;
}
.pr-0{
  padding-right: 0px;
}
.pt-0{
  padding-top: 0px;
}
.pt-2{
  padding-top: 0.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-start{
  text-align: start;
}
.text-end{
  text-align: end;
}
.align-middle{
  vertical-align: middle;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.leading-\\[18px\\]{
  line-height: 18px;
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}
.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
@media (min-width: 768px){
  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:block{
    display: block;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:justify-center{
    justify-content: center;
  }
  .md\\:p-2{
    padding: 0.5rem;
  }
}
@media (prefers-color-scheme: dark){
  .dark\\:border-gray-700{
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .dark\\:bg-gray-700{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:bg-gray-800{
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
  .dark\\:text-gray-200{
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-600:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:bg-gray-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }
  .dark\\:hover\\:text-white:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/pages/home-demo-four/search-engine/search-engine.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,2DAAA;AACA,gCAAA;AAEA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EAEA,QAAA;EAIA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AANF;;AAQA;EACE,uBAAA;EACA,cAAA;EACA,cAAA;AAEF;;AAAA;EAGE,4CAAA;EACA,yBAAA;AAGF;;AADA;EACE,oCAAA;EACA,cAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,kCAAA;AAMF;;AAHA;EACE,8BAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,SAAA;EACA,iBAAA;AAMF;;AAHA;EACE,8BAAA;EACA,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,WAAA;EAEA,+BAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,kBAAA;EAAoB,mBAAA;EAAoB,mBAAA;AAO1C;;AAJA;EACE,kBAAA;EAAoB,mBAAA;AAQtB;;AALA;EACE,uBAAA;EACA,wBAAA;EACA,2BAAA;AAQF;;AALA;EACE,mBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EAEA,yBAAA;AAOF;;AALA;EACE,oCAAA;AAQF;;AALA;EAGE,WAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EAEA,eAAA;EACA,gBAAA;EACA,QAAA;AAKF;;AAHA;EACE,6BAAA;AAMF;;AAJA;EACE,QAAA;EACA,4BAAA;EACA,aAAA;EACA,4BAAA;EACA,uBAAA;EACA,0BAAA;EACA,WAAA;AAOF;;AAJA;EACE,yBAAA;AAOF;;AALA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AAQF;;AALA;EACE,cAAA;EACA,WAAA;EAEA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEAAA;EAGA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;AASF;;AAPA;EACE,yDAAA;EACA;IACE,uBAAA;IACA,2BAAA;EAUF;AACF;AAPA,8BAAA;AAEA;EAIE,aAAA;AAQF;;AALA;EAGE,gBAAA;EACA,eAAA;EACA,YAAA;AAQF;;AALA;EACE,WAAA;EACA,YAAA;AAQF;;AALA;EACE,kBAAA;AAQF;;AALA;EACE,eAAA;EACA,6BAAA;EACA,iBAAA;AAQF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,cAAA;AAQF;;AALA;EACE,WAAA;EACA,yBAAA;AAQF;;AALA;EACE,WAAA;AAQF;;AANA;EAIE,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;AAMF;AAbE;EACE,+BAAA;AAeJ;;AANA;EACE,oBAAA;AASF;;AALA;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,wCAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,cAAA;AAQF;;AAHA,iDAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EAIA,oBAAA;EAGA,wCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAKF;;AADA;EACE;IACE,0BAAA;EAIF;AACF;AAAA;EAGE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,qBAAA;AAAF;;AAGA;EACE,UAAA;EACA,eAAA;EAMA,0CAAA;EAAA,kCAAA;EACA,YAAA;AADF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,OAAA;EACA,yBAAA;EACA,YAAA;AAAF;;AAGA;EAGE,oDAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,4CAAA;EACA,6BAAA;AAAF;;AAKA,aAAA;AACA;EACE,sBAAA;AAFF;;AAKA;EACE,YAAA;EACA,aAAA;AAFF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,WAAA;EACA,2DAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAKA;EACE,kBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAKA,aAAA;AACA;EACE,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,mCAAA;AAFF;;AAIA;EACE,QAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;AADF;;AAIA;EACE,YAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6BAAA;EAGA,cAAA;EACA,sBAAA;EAGA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EAGA,aAAA;EACA,YAAA;EACA,WAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAIA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AADF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;AAFF;;AAKA;EACE,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,sBAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAKA;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EAIA,+GAAA;AANF;;AASA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AANF;;AASA;;EAEE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EAKA,0BAAA;EACA,4IAAA;EAUA,sNAAA;AAhBF;;AA6BA;;EAEE,cAAA;AA1BF;;AA4BA;;EAEE,oBAAA;AAzBF;;AA2BA;;EAEE,oBAAA;AAxBF;;AA0BA;EACE,sBAAA;AAvBF;;AAyBA;EACE,qBAAA;AAtBF;;AAyBA;EACE,sBAAA;AAtBF;;AAyBA;EACE,qBAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EAKA,0BAAA;EACA,qEAAA;EAMA,+GAAA;AA5BF;;AAqCA;EACE,mBAAA;EACA,YAAA;EACA,+BAAA;EACA,6BAAA;EAIA,8BAAA;EACA,mBAAA;EAEA,6BAAA;AArCF;;AAuCA;EACE,cAAA;AApCF;;AAsCA;EACE,gBAAA;EACA,6BAAA;EAIA,oBAAA;AApCF;;AAsCA,aAAA;AACA;EACE,gBAAA;EACA,6BAAA;AAnCF;;AAqCA;;;EAGE,aAAA;AAlCF;;AAoCA;EACE,qBAAA;EACA,oGAAA;AAjCF;;AAoCA;EACE,UAAA;AAjCF;;AAoCA;EACE,cAAA;EACA,UAAA;EAEA,kBAAA;EACA,QAAA;AAlCF;AAmCE;EACE,QAAA;AAjCJ;;AAqCA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA,gEAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;AACA;EAAA,WAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;IAAA,iBAAA;EAAA;AAAA;AACA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA;IAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,2BAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,eAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,kDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAjsBA;EAAA,kBAisBA;EAjsBA,0DAAA;AAisBA;AAjsBA;EAAA,kBAisBA;EAjsBA,4DAAA;AAisBA;AAjsBA;EAAA,kBAisBA;EAjsBA,yDAAA;AAisBA;AAjsBA;EAAA,+BAAA;AAisBA;AAjsBA;EAAA,+EAisBA;EAjsBA,mGAisBA;EAjsBA,uGAAA;AAisBA;AAjsBA;EAAA,8BAisBA;EAjsBA,mBAAA;AAisBA;AAjsBA;EAAA,2GAisBA;EAjsBA,yGAisBA;EAjsBA,4FAAA;AAisBA;AAjsBA;EAAA,oBAisBA;EAjsBA,6DAAA;AAisBA;AAjsBA;EAAA;IAAA,4BAAA;EAisBA;EAjsBA;IAAA,4BAAA;EAisBA;EAjsBA;IAAA,cAAA;EAisBA;EAjsBA;IAAA,aAAA;EAisBA;EAjsBA;IAAA,gDAAA;EAisBA;EAjsBA;IAAA,gDAAA;EAisBA;EAjsBA;IAAA,uBAAA;EAisBA;EAjsBA;IAAA,eAAA;EAisBA;AAAA;AAjsBA;EAAA;IAAA,sBAisBA;IAjsBA,yDAAA;EAisBA;EAjsBA;IAAA,kBAisBA;IAjsBA,yDAAA;EAisBA;EAjsBA;IAAA,kBAisBA;IAjsBA,yDAAA;EAisBA;EAjsBA;IAAA,oBAisBA;IAjsBA,mDAAA;EAisBA;EAjsBA;IAAA,kBAisBA;IAjsBA,yDAAA;EAisBA;EAjsBA;IAAA,kBAisBA;IAjsBA,yDAAA;EAisBA;EAjsBA;IAAA,oBAisBA;IAjsBA,mDAAA;EAisBA;AAAA;AAqgCA,o8kCAAo8kC","sourcesContent":["/*@import url(\"moteur-recherche-remplace.component.scss\");*/\n/* Import Tailwind base styles */\n\n:host(.home_search) .moteur-de-recherhe{\n  display: block;\n  width: 790px;\n  position: absolute;\n  z-index: 2;\n  top: 50%;\n}\n\n:host(.home_search) .moteur-de-recherhe{\n  position: relative;\n  z-index: 5;\n  margin-left: auto;\n  margin-right: auto;\n}\n:host(.home_search){\n  width: 790px !important;\n  display: block;\n  margin: 0 auto;\n}\n:host(.dark) .moteur-de-recherhe{\n  -moz-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.33);\n  -webkit-box-shadow: 0px 3px 15px rgb(0 0 0 / 33%);\n  box-shadow: 0px 3px 15px rgb(0 0 0 / 33%);\n  background-color: #4c4c4c;\n}\n:host(.dark) ::ng-deep .moteur-de-recherhe .dynamique-style{\n  background-color: #4c4c4c !important;\n  color: #dddddd;\n}\n:host(.dark) ::ng-deep .moteur-de-recherhe input::placeholder{\n  color: #868484;\n}\n:host(.light) ::ng-deep .moteur-de-recherhe input{\n  background: transparent !important;\n}\n\n.moteur-de-recherhe{\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n  text-align: left;\n  color: #242526;\n  box-sizing: border-box;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  background: #fff;\n  border-radius: 50px;\n  padding: 0px 7px 0px 10px;\n  height: 65px;\n  width: 100%;\n  display: flex !important;\n  margin: 0;\n  flex-wrap: nowrap;\n}\n\n.zone-input{\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n  text-align: left;\n  color: #242526;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  float: left;\n\n  border-right: 1px solid #6d6c6c;\n}\n\n.zone-input-qui{\n  border-right: none;\n}\n\n.zone-input-qui > div{\n  position: relative;\n}\n\n.input-ou{\n  position: relative; vertical-align: top;margin-bottom: 15px;\n}\n\n.input-qui{\n  position: relative; vertical-align: top;\n}\n\ninput:focus{\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.btn {\n  border-radius: 50px;\n  margin: 7px 0px;\n  border: 0;\n  color: #fff;\n  overflow: hidden;\n  z-index: 1;\n  // background-color: #1976d2;\n  background-color: #009688;\n}\n.search-additional-btn:hover{\n  background-color: rgb(226, 225, 225);\n}\n\n.search-additional-btn {\n  // background-color: #242526;\n\n  width: 22px;\n  border-radius: 0 55px 55px 0;\n  margin: 7px 0px;\n  margin-left: 8px;\n  padding: 0 5px;\n  height: 51px;\n  line-height: 51px;\n  float: right;\n  border: 0;\n  font-size: 14px;\n  color: #1976d2;\n  box-shadow: none;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  // background-color: #ffffff;\n  cursor: pointer;\n  will-change: all;\n  order: 5;\n}\n.padd{\n  padding-left: 13px !important;\n}\n.search-additional-btn-left{\n  order: 0;\n  border-radius: 55px 0 0 55px;\n  margin: 7px 0;\n  margin-right: 0px !important;\n  padding: 0px !important;\n  max-width: 32px !important;\n  float: left;\n}\n\n.search-additional-btn-rigth{\n  margin-left: 0 !important;\n}\n.form-group {\n  margin: 0px;\n  padding: 0;\n  float: left;\n  width: 100%;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding-left: 12px !important;\n  padding: .375rem .75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: .25rem;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n.form-control {\n  font-size: 14px;\n  font-weight: 500;\n  height: 46px;\n  border: 0px;\n  margin: 9px 0px 10px 0px;\n  border-radius: 0px;\n  padding-left: 25px;\n}\n\n.autocomplete{\n  position: absolute;\n  top:20px;\n  left:-50px;\n  width: 200% !important;\n  z-index: 8;\n  background-color: white;\n  border-radius: 0.5em;\n  max-width: 415px !important;\n}\n@media only screen and (max-width: 600px) {\n  /* Appareils avec une résolution de 600 pixels ou moins */\n  .autocomplete{\n    left: -110px !important;\n    max-width: 590px !important;\n  }\n}\n\n/*******Autocomplete**********/\n\n.searchbar-result-profile {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex\n}\n\n.searchbar-result-profile-avatar {\n  -webkit-flex-basis: 40px;\n  -ms-flex-preferred-size: 40px;\n  flex-basis: 40px;\n  min-width: 40px;\n  height: 40px\n}\n\n.searchbar-result-profile-avatar img {\n  width: 100%;\n  height: 100%\n}\n\n.searchbar-result-profile-details {\n  padding-left: 14px\n}\n\n.searchbar-result-profile-city {\n  font-size: 12px;\n  color: rgba(67, 95, 113, .6);\n  line-height: 14px\n}\n\n\n:host(.home_search) .moteur-de-recherhe .search-additional-btn{\n  color: #0f847e;\n}\n:host(.home_search) .moteur-de-recherhe .zone-input{\n  color: #0f847e;\n}\n\n:host(.home_search) .moteur-de-recherhe .btn{\n  color: #fff;\n  background-color: #0f847e;\n}\n\n:host(.home_search) .moteur-de-recherhe .fa-search.fa-w-16{\n  color: #fff;\n}\n:host(.home_search) .moteur-de-recherhe input{\n  :first-child{\n    border-right: 1px solid #7f7d7d;\n  }\n  /*font-family: Roboto;*/\n  font-size: 16px;\n  font-weight: normal;\n  caret-color: #fff;\n  background: transparent !important;\n}\n\n.loc {\n  padding: 6px 0 0 6px;\n}\n\n\n.btn-search{\n  width: 15%;\n  float: right;\n  height: 100%;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: transparent;\n  text-align: left;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  color: #0f847e;\n}\n\n\n\n/***************** Result block *****************/\n.result-block {\n  position: absolute;\n  z-index: 90;\n  top: 3.667em;\n  /*right: -0.25em;*/\n  /*min-width: 30em;*/\n  background: white;\n  -moz-border-radius: 0.5em;\n  -webkit-border-radius: 0.5em;\n  // -webkit-background-clip: padding-box;\n  border-radius: 0.5em;\n  -moz-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);\n  -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);\n  /*padding: 1em;*/\n  line-height: 1em;\n  text-align: left;\n  color: #333333;\n}\n\n\n@media (min-width: 991px) {\n  .result-block {\n    min-width: 29em!important;\n  }\n}\n\n\n.result-block .scroll {\n  // height: 240px;\n\n  overflow: auto;\n  overflow-y : auto;\n  overflow-x: hidden;\n  max-height: 200px;\n\n}\n.result-block .spec-search {\n  width: 100%;\n  display: inline-block;\n}\n\n.result-block .scroll::-webkit-scrollbar {\n  width: 8px;\n  cursor: pointer;\n\n  -webkit-transition: opacity 1s ease-in-out;\n  -moz-transition: opactiy 1s ease-in-out;\n  -ms-transition: opacity 1s ease-in-out;\n  -o-transition: opacity 1s ease-in-out;\n  transition: opacity 1s ease-in-out;\n  opacity: 0.1;\n}\n.result-block .scroll::-webkit-scrollbar:hover {\n  transition: none;\n  -o-transition: none;\n  -ms-transition: none;\n  -moz-transition: none;\n  -webkit-transition: none;\n  zoom: 1;\n  filter: alpha(opacity=50);\n  opacity: 0.9;\n}\n\n.result-block .scroll::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0px 0px 6px 0px rgba(0,0,0,0.3);\n  -moz-box-shadow: inset 0px 0px 6px 0px rgba(0,0,0,0.3);\n  box-shadow: inset 0px 0px 6px 0px rgba(0,0,0,0.3);\n  -o-shadow: inset 0px 0px 6px 0px rgba(0,0,0,0.3);\n  -ms-shadow: inset 0px 0px 6px 0px rgba(0,0,0,0.3);\n  background: rgb(204, 204, 204);\n  /* border-radius: 4px; */\n  margin-bottom: 7px;\n}\n\n.result-block .scroll::-webkit-scrollbar-thumb {\n  -box-shadow: inset 0 0 6px rgb(48, 143, 183);\n  background: rgb(48, 143, 183);\n\n}\n\n\n/* IE class */\n.ie .result-block {\n  border: 1px solid #ccc;\n}\n\n#status-infos .result-block {\n  top: 2.667em;\n  display: none;\n}\n#status-infos > li:hover .result-block {\n  display: block;\n}\n\n.result-block h2 {\n  float: left;\n  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);\n  opacity: 0.8;\n  color: #11b3a4;\n  font-size: 19px;\n  font-weight: 600;\n  padding-left: 10px;\n  padding-top: 7px;\n}\n\n// .result-block > div\n.ab{\n  margin-bottom: 1px;\n  //\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 250px;\n  //\n}\n.result-block div:last-child {\n  margin-bottom: 0;\n}\n/* IE class */\n.result-block div.last-child {\n  margin-bottom: 0;\n}\n\n.result-block .arrow {\n  font-size: 0;\n  line-height: 0;\n  width: 0;\n  position: absolute;\n  z-index: 89;\n  right: 50%;\n  top: -5px;\n  border-bottom: 5px solid #666666;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n}\n.result-block .arrow span {\n  width: 0;\n  position: absolute;\n  z-index: 89;\n  left: -2px;\n  bottom: -5px;\n  border-bottom: 4px solid white;\n  border-left: 2px solid transparent;\n  border-right: 2px solid transparent;\n}\n\n.result-block .results-count {\n  float: right;\n  text-transform: uppercase;\n  color: #676767;\n  font-size: 0.85em;\n  white-space: nowrap;\n  margin-left: 1em;\n  padding-top: 15px;\n  padding-right: 10px;\n  margin-bottom: 8px;\n}\n.result-block .results-count strong {\n  color: #999999;\n}\n\n.result-block ul {\n  clear: both;\n}\n.result-block ul li {\n  white-space: nowrap;\n}\n\n.result-block .speciality {\n  border-top: 1px solid #efefef;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  -webkit-flex-basis: 100%;\n  -ms-flex-preferred-size: 100%;\n  flex-basis: 100%;\n  max-width: 100%;\n  font-size: 14px;\n  color: #435f71;\n  position: relative;\n  cursor: pointer;\n  text-align: left;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 8px;\n  clear: both;\n\n  margin-bottom: 0px;\n}\n\n.result-block .speciality:hover {\n  background-color: #efefef;\n}\n\n.result-block .speciality strong {\n  color: #11b3a4;\n}\n\n\n.result-block .table-profiles {\n  padding: 0;\n  width: 100%;\n  /*display: table;*/\n  margin: 0;\n  clear: both;\n\n  // height: 250px !important;\n}\n.result-block .table-profile {\n  z-index: 100000;\n  padding: 5px 0;\n  margin: 0;\n  height: 86px;\n  clear: both;\n  border-bottom: 1px solid #efefef;\n}\n\n.result-block .table-profile:hover {\n  cursor: pointer;\n  background-color: #efefef;\n}\n\n.result-block .table-profiles .table-cell{\n  display: inline-grid;\n  vertical-align: middle;\n}\n.result-block .table-profiles .table-cell:first-child{\n  padding: 5px;\n\n\n}\n.result-block .table-profiles .table-cell .img-circle{\n  border-radius: 50%;\n\n  width: 60px;\n  height: 60px;\n\n\n\n  box-shadow: 0 4px 6px -10px rgba(0,0,0,0.5), 0 1px 4px rgba(0,0,0,0.3), 0 0 30px rgba(0,0,0,0.1) inset;\n\n}\n.profile-info .name-text{\n  margin-left: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n\n.profile-info strong{\n  color: #0fa0d7;\n}\n\n.profile-info .spec{\n  font-size: 13px;\n  margin: 3px 0px 3px 10px;\n  max-width: 300px;\n  color: grey;\n  font-style: italic;\n  font-family: sans-serif;\n}\n\n.profile-info .location{\n  display: flex;\n  align-items: center;\n  justify-self: start;\n  font-size: 14px;\n  margin-left: 6px;\n  font-weight: 600;\n  color: #4c4c4c;\n}\n\n.search-more,\n.search-less {\n  display: block;\n  color: #999999;\n  font-size: 0.75em;\n  text-transform: uppercase;\n  padding: 0.333em 0;\n  text-align: center;\n  // background: url(../images/old-browsers-bg/search-more-shadow.png) no-repeat center bottom;\n  -webkit-background-size: 100% 100%;\n  -moz-background-size: 100% 100%;\n  -o-background-size: 100% 100%;\n  background-size: 100% 100%;\n  background: -moz-linear-gradient(\n      top,\n      rgba(255, 255, 255, 1),\n      rgba(255, 255, 255, 0)\n  ), -moz-linear-gradient(\n      left,\n      #ffffff,\n      #ebebeb 50%,\n      #ffffff\n  );\n  background: -webkit-gradient(\n      linear,\n      left top, left bottom,\n      from(rgba(255, 255, 255, 1)),\n      to(rgba(255, 255, 255, 0))\n  ), -webkit-gradient(\n      linear,\n      left top, right top,\n      from(#ffffff),\n      to(#ffffff),\n      color-stop(0.5, #ebebeb)\n  );\n}\n.search-more:hover,\n.search-less:hover {\n  color: #3399cc;\n}\nul + .search-more,\nul + .search-less {\n  margin-top: -1.333em;\n}\nul.small-pagination + .search-more,\nul.small-pagination + .search-less {\n  margin-top: -0.667em;\n}\n.search-more:before {\n  padding-right: 0.556em;\n}\n.search-more:after {\n  padding-left: 0.556em;\n}\n\n.search-less:before {\n  padding-right: 0.556em;\n}\n\n.search-less:after {\n  padding-left: 0.556em;\n}\n\n.result-block hr {\n  height: 1px;\n  line-height: 1px;\n  border: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  clear: both;\n  // background: #ffffff url(../images/old-browsers-bg/search-sep-bg.png) repeat-y left;\n  -webkit-background-size: 100% 100%;\n  -moz-background-size: 100% 100%;\n  -o-background-size: 100% 100%;\n  background-size: 100% 100%;\n  background: -moz-linear-gradient(\n      left,\n      #ffffff,\n      #cccccc 50%,\n      #ffffff\n  );\n  background: -webkit-gradient(\n      linear,\n      left top, right top,\n      from(#ffffff),\n      to(#ffffff),\n      color-stop(0.5, #cccccc)\n  );\n}\n\n.result-block .result-info {\n  background: #333333;\n  color: white;\n  padding: 0.417em 0.75em 0.583em;\n  /* margin: 0 -1em -1em -1em;*/\n  -moz-border-radius: 0 0 0.5em 0.5em;\n  // -webkit-border-bottom-right-radius: 0.5em;\n  // -webkit-border-bottom-left-radius: 0.5em;\n  border-radius: 0 0 0.5em 0.5em;\n  white-space: nowrap;\n\n  margin-bottom: 0px !important;\n}\n.result-block .result-info a {\n  color: #77ccff;\n}\n.result-block .arrow:first-child + .result-info:last-child {\n  margin-top: -1em;\n  border-top: 1px solid #999999;\n  -moz-border-radius: 0.5em;\n  -webkit-border-radius: 0.5em;\n  // -webkit-background-clip: padding-box;\n  border-radius: 0.5em;\n}\n/* IE class */\n.result-block .result-info.first-last-child {\n  margin-top: -1em;\n  border-top: 1px solid #999999;\n}\n.result-block div + .result-info,\n.result-block p + .result-info,\n.result-block ul + .result-info {\n  margin-top: 0;\n}\n.result-block .result-info.loading {\n  padding-left: 2.667em;\n  background: #333333 url(https://cdn.tictacsante.com/assets/icons/loader.gif) no-repeat 0.75em center;\n}\n\n.result-block-loc {\n  top: 9.3em;\n}\n\n:host(.home_search) .moteur-de-recherhe{\n  display: block;\n  z-index: 2;\n  // width: 790px !important;\n  position: absolute;\n  top: 50%;\n  .result-block-loc {\n    top: 5em;\n  }\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
